import axios from "axios";
const apiURL = process.env.VUE_APP_API_URL + "trucks/";
import authHeader from "../services/auth-header";
export const trucks = {
  state: {
    truck: {},
    trucks: [],
    steam: [],
  },
  getters: {
    oneTruck: (state) => state.truck,
    allTrucks: (state) => state.trucks,
  },
  mutations: {
    setTruck(state, truck) {
      state.truck = truck;
    },
    setTrucks(state, trucks) {
      state.trucks = trucks;
    },
    setSteam(state, steam) {
      state.steam = steam;
    },
    editTruck(state, truck) {
      let trucks = state.trucks;

      let index = trucks.findIndex((element) => element._id === truck._id);
      if (index != -1) {
        trucks[index].station = truck.station;
        state.trucks = trucks;
      }
    },
    deleteTruck(state, id) {
      let trucks = state.trucks;

      let filterTruck = trucks.filter((element) => element._id !== id);

      state.trucks = filterTruck;
    },
  },
  actions: {
    getTrucks(context) {
      return axios
        .get(apiURL, { headers: authHeader() })
        .then((res) => {
          context.commit("setTrucks", res.data);
          return res;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    deleteTrucks(context, id) {
      return axios
        .delete(apiURL + id, { headers: authHeader() })
        .then((res) => {
          context.commit("deleteTruck", id);
          return res;
        })
        .catch((error) => {
          console.log(error.response);
          return error.response;
        });
    },
    editTrucks(context, data) {
      return axios
        .put(
          apiURL + data._id,
          {
            station: data.station,
            sector: data.sector,
            office: data.office,
          },
          { headers: authHeader() }
        )
        .then((res) => {
          context.commit("editTruck", data);
          return res;
        })
        .catch((error) => {
          return error.response;
        });
    },
    async getTruck(context, id) {
      return axios
        .get(apiURL + id, { headers: authHeader() })
        .then((res) => {
          context.commit("setTruck", res.data);

          return res;
        })
        .catch((error) => {
          return error.res;
        });
    },
    getSteam(context, id) {
      return axios
        .get(apiURL + "linksteam/" + id, { headers: authHeader() })
        .then((res) => {
          context.commit("setSteam", res.data);
          return res;
        })
        .catch((error) => {
          return error.res;
        });
    },
  },
};
